<template>
  <div class="replacementstatistics__report__view">
    <div class="reports__subheader">
      <period-panel
        :dateFrom="startDate"
        :dateTo="endDate"
        @dateFrom="(value) => (this.startDate = value)"
        @dateTo="(value) => (this.endDate = value)"
      >
      </period-panel>

      <group-panel @groupId="(value) => (this.forGroup = value)" 
        :addDefault="this.filter.forGroup === undefined ? true : false"
        :value="forGroup">
      </group-panel>

      <region-panel
        :region="forRegion"
        @selectionChanged="(value) => (this.forRegion = value)"
      >
      </region-panel>

      <submit-panel @submit="performLookup"> </submit-panel>

      <div class="reports__panel--submit" v-if="generalReportForPeriod.length > 0">
        <b-button class="button is-primary" @click="openSidebarAsync()">
          Filtrere medarbejdere
        </b-button>
      </div>
    </div>

    <b-table
      :data="generalReportForPeriod"
      :loading="loading"
      default-sort="number"
      hoverable
    >
      <b-table-column
        field="number"
        label="Ins. nr."
        v-slot="props"
        sortable
        numeric
      >
        {{ props.row.number }}
      </b-table-column>

      <b-table-column field="name" label="Inseminør" v-slot="props" sortable>
        {{ props.row.name }}
      </b-table-column>

      <b-table-column
        field="weekday"
        label="Arbejde"
        v-slot="props"
        numeric
        cell-class="cell-note"
      >
        {{ props.row.weekday }}
      </b-table-column>

      <b-table-column
        field="saturday"
        label="Arbejde lørdag"
        v-slot="props"
        numeric
      >
        {{ props.row.saturday }}
      </b-table-column>

      <b-table-column
        field="sunday"
        label="Arbejde søndag"
        v-slot="props"
        numeric
        cell-class="cell-note"
      >
        {{ props.row.sunday }}
      </b-table-column>

      <b-table-column field="vacation" label="Ferie" v-slot="props" numeric>
        {{ props.row.vacation }}
      </b-table-column>

      <b-table-column
        field="offDay"
        label="Fri"
        v-slot="props"
        numeric
        cell-class="cell-note"
      >
        {{ props.row.offDay }}
      </b-table-column>

      <b-table-column
        field="timeoff"
        label="Afspadsering"
        v-slot="props"
        numeric
      >
        {{ props.row.timeOff }}
      </b-table-column>

      <b-table-column
        field="otherWork"
        label="Andet"
        v-slot="props"
        numeric
        cell-class="cell-note"
      >
        {{ props.row.otherWork }}
      </b-table-column>

      <b-table-column field="id" label="#" v-slot="props" numeric>
        <router-link
          :to="{
            name: 'MonthlyStatistics',
            params: { employeeNumber: props.row.number },
          }"
          >Månedsrapport</router-link
        >
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from "@/enums/APISTATE";
import PeriodPanel from "@/components/report/PeriodPanel.vue";
import RegionPanel from "@/components/report/RegionPanel.vue";
import SubmitPanel from "@/components/report/SubmitPanel.vue";
import GroupPanel from "@/components/report/GroupPanel.vue";
import Vue from "vue";

export default {
  name: "generalstatistics-report-view",
  components: { PeriodPanel, RegionPanel, SubmitPanel, GroupPanel },
  data: () => ({
    startDate: undefined,
    endDate: undefined,
    forRegion: undefined,
    forGroup: undefined,
  }),
  async mounted() {
    if (this.filter.startDate === undefined && this.filter.endDate === undefined) {
      this.startDate = new Date(new Date().getFullYear(), 0, 1);
      this.endDate = new Date(new Date().getFullYear(), 11, 31);
    } else {
      this.startDate = this.filter.startDate;
      this.endDate = this.filter.endDate;
      this.forRegion = this.filter.forRegion;
      this.forGroup = this.filter.forGroup;
    }
  },
  methods: {
    ...mapActions("reportStore", [
      "getGeneralReportForPeriod",
      "setGeneralReportForPeriod",
    ]),
    ...mapActions("generalStatisticsFilteringSidebar", [
      "sidebarOpenAsync",
      "setIsOpen",
      "setGroupMembers",
      "setFilter",
    ]),
    async performLookup() {
      if (this.endDate && this.startDate) {
        const model = {
          startDate: this.startDate,
          endDate: this.endDate,
          forRegion: this.forRegion,
          forGroup: this.forGroup,
        };
        this.setFilter(model);
        await this.getGeneralReportForPeriod(model);
      }
    },
    async openSidebarAsync() {
      this.setGroupMembers(this.generalReportForPeriod);
      await this.sidebarOpenAsync()
        .then(async (response) => {
          if (response.action === "update") {
            await this.setGeneralReportForPeriod(response.markedGroupMembers);
          }
        })
        .catch((error) => console.error(error));
    },
  },
  computed: {
    ...mapGetters("reportStore", [
      "generalReportForPeriodApiState",
      "generalReportForPeriod",
    ]),
    ...mapGetters("generalStatisticsFilteringSidebar", ["filter"]),
    loading() {
      return this.generalReportForPeriodApiState === APISTATE.LOADING;
    },
  },
};
</script>

<style lang="scss"></style>
